/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["underscore", "backbone", "service/channel", "service/stub", "service/wiring", "model/readonlytree", "model/tree", "model/computed", "utils/events"],
  function(_, Backbone, Channel, ServiceStub, ServiceWiring, ReadOnlyTreeModel, TreeModel, ComputedModel, Events) {


  var ServiceFactory = function() {

  }

  _.extend(ServiceFactory.prototype, Backbone.Events, Events, {

    createStub: function() { return new ServiceStub(); },

    createInput: function(attrs,options) {
      var model = new TreeModel(attrs, options);
      this.proxyEvent({"before:serialize": "before:serializeinput"}, model);
      return model;
    },

    createOutput: function(attrs,options) {
      var model = new ReadOnlyTreeModel(attrs, options);
      this.proxyEvent({"load": "loadoutput"}, model);
      return model;
    },

    // returns a function that creates a new ServiceWiring depending only on the
    // input and output parameters.
    createWiring: function(channel, options) {

      options = options || {};
      var input = options.input || this.createInput();
      var output = options.output || this.createOutput();

      var wiringOptions = _.extend({channel: channel}, options);
      delete wiringOptions.input;
      delete wiringOptions.output;

      if (!wiringOptions.serviceStub) {
        wiringOptions.serviceStub = this.createStub();
      }

      return new ServiceWiring(input, output, wiringOptions);
    },

    createModel: function(channel, options) {
      var model = new ComputedModel(this.createWiring(channel,options), options);
      this.proxyEvent("compute", model);
      return model;
     }
  });

  return ServiceFactory;

});
